import apiService from 'src/enviroment'

const rejectionReazon = async (chasis, id) => {
  const { data, status } = await apiService.get(
    `mei/razones_rechazo/?chasis=${chasis}&cedula=${id}`,
  )
  try {
    if (status === 200) {
      return data
    }
    return false
  } catch (error) {
    console.log('Error get List ')
  }
}

const rejectReazonByPlaca = async (placa, id) => {
  const response= await apiService.get(
    `/placa/razones_rechazo/?placa=${placa}&cedula=${id}`,
  )
  try {
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.log('Error get List ')
  }
}

const glukyService = {
  getLines: () => apiService.get('/puntos/lineasmobility/'),
  getPoints: () => apiService.get('/puntos/gluky/'),
  postPoints: (body) => apiService.post('/puntos/gluky/', body),
  putPoints: (params) => {
    const body = params.newData
    return apiService.put('/puntos/gluky/', body)
  },
  deletePoints: (params) =>
    apiService.delete(`/puntos/gluky/?linea=${params.linea}`),
  rejectionReazon,
  rejectReazonByPlaca,
}
export default glukyService
